
        <div class="arrow" (click)="onClick()" 
        [ngClass]="{ left : dir === 'left', right : dir === 'right', disabled  : disabled}"></div>
    